import { debounce } from 'lodash';

N2.ready(() => {
  new N2Styles.searchBar({safeContainer: '.js-search-1', inputSelector: "input[name='q']"})

  $('.js-general-search').typeahead({
    minLength: 2,
    highlight: true
  }, {
    source: debounce((query, syncResults, asyncResults) => {
      $.get('/search/autocomplete?q=' + query, function(data) {
        asyncResults(data);
      });
    }, 400),
  }).bind('typeahead:select', (evt, suggestion) => {
    let $form = $($(evt.currentTarget).closest('form'));
    $form.submit();
  });

  $(document).on('click', '.show-search-input', function(e){
    $('.n2-search-bar').find('input').focus()
  })

  N2.unload(function(){
    $('.js-general-search').typeahead('destroy')
  })
})
